const paintings6 = [
  {
    id: '6_01',
    name: 'River in Winter',
    imageSrc: 'level6/6_01.jpg',
    cutSrc: 'level6/cut/6_01.jpg',
    author: 'NEER, Aert van der',
    year: 'c. 1645',
  },
  {
    id: '6_02',
    name: 'Card-Sharpers',
    imageSrc: 'level6/6_02.jpg',
    cutSrc: 'level6/cut/6_02.jpg',
    author: 'OOST, Jacob van, the Elder',
    year: '1634',
  },
  {
    id: '6_03',
    name: 'Farmhouse',
    imageSrc: 'level6/6_03.jpg',
    cutSrc: 'level6/cut/6_03.jpg',
    author: 'OUDRY, Jean-Baptiste',
    year: '1750',
  },
  {
    id: '6_04',
    name: 'An Elegant Company in an Interior',
    imageSrc: 'level6/6_04.jpg',
    cutSrc: 'level6/cut/6_04.jpg',
    author: 'PALAMEDESZ., Anthonie',
    year: '1632-34',
  },
  {
    id: '6_05',
    name: 'View of the Forum Looking towards the Capitol',
    imageSrc: 'level6/6_05.jpg',
    cutSrc: 'level6/cut/6_05.jpg',
    author: 'PANNINI, Giovanni Paolo',
    year: '1751',
  },
  {
    id: '6_06',
    name: 'Allegory of Life and Death',
    imageSrc: 'level6/6_06.jpg',
    cutSrc: 'level6/cut/6_06.jpg',
    author: 'PAOLINI, Pietro',
    year: '1628-32',
  },
  {
    id: '6_07',
    name: 'View of a Southern Coast',
    imageSrc: 'level6/6_07.jpg',
    cutSrc: 'level6/cut/6_07.jpg',
    author: 'PEETERS, Bonaventura',
    year: '1652',
  },
  {
    id: '6_08',
    name: 'A Cowherd at Pontoise',
    imageSrc: 'level6/6_08.jpg',
    cutSrc: 'level6/cut/6_08.jpg',
    author: 'PISSARRO, Camille',
    year: '1874',
  },
  {
    id: '6_09',
    name: 'Lordship Lane Station, Dulwich',
    imageSrc: 'level6/6_09.jpg',
    cutSrc: 'level6/cut/6_09.jpg',
    author: 'PISSARRO, Camille',
    year: '1871',
  },
  {
    id: '6_10',
    name: 'Children of Frederick V Prince Elector of Pfalz and King of Bohemia',
    imageSrc: 'level6/6_10.jpg',
    cutSrc: 'level6/cut/6_10.jpg',
    author: 'POELENBURGH, Cornelis van',
    year: '1628',
  },
  {
    id: '6_11',
    name: 'Capriccio View of Rome with the Martyrdom of St Lawrence',
    imageSrc: 'level6/6_11.jpg',
    cutSrc: 'level6/cut/6_11.jpg',
    author: 'POELENBURGH, Cornelis van',
    year: '1622-25',
  },
  {
    id: '6_12',
    name: 'Landscape with Shepherdess and Shepherd Playing Flute',
    imageSrc: 'level6/6_12.jpg',
    cutSrc: 'level6/cut/6_12.jpg',
    author: 'POTTER, Paulus',
    year: 'c. 1643',
  },
  {
    id: '6_13',
    name: 'Fisherwomen by the Shore',
    imageSrc: 'level6/6_13.jpg',
    cutSrc: 'level6/cut/6_13.jpg',
    author: 'RASMUSSEN, Georg Anton',
    year: '1883',
  },
  {
    id: '6_14',
    name: 'Fjord in Norway',
    imageSrc: 'level6/6_14.jpg',
    cutSrc: 'level6/cut/6_14.jpg',
    author: 'RASMUSSEN, Georg Anton',
    year: '1891',
  },
  {
    id: '6_15',
    name: 'The Pont des Arts, Paris',
    imageSrc: 'level6/6_15.jpg',
    cutSrc: 'level6/cut/6_15.jpg',
    author: 'RENOIR, Pierre-Auguste',
    year: '1867',
  },
  {
    id: '6_16',
    name: 'A Capriccio Landscape with a Domed Church',
    imageSrc: 'level6/6_16.jpg',
    cutSrc: 'level6/cut/6_16.jpg',
    author: 'RICCI, Marco',
    year: '1710s',
  },
  {
    id: '6_17',
    name: 'Architectural Capriccio',
    imageSrc: 'level6/6_17.jpg',
    cutSrc: 'level6/cut/6_17.jpg',
    author: 'RICCI, Marco',
    year: 'c. 1725',
  },
  {
    id: '6_18',
    name: 'Bridal Procession in a Spring Landscape',
    imageSrc: 'level6/6_18.jpg',
    cutSrc: 'level6/cut/6_18.jpg',
    author: 'RICHTER, Adrian Ludwig',
    year: '1847',
  },
  {
    id: '6_19',
    name: 'Venice, Approach to the Grand Canal',
    imageSrc: 'level6/6_19.jpg',
    cutSrc: 'level6/cut/6_19.jpg',
    author: 'ROBERTS, David',
    year: '1855',
  },
  {
    id: '6_20',
    name: 'A Battle Scene',
    imageSrc: 'level6/6_20.jpg',
    cutSrc: 'level6/cut/6_20.jpg',
    author: 'ROSA, Salvator',
    year: '1640s',
  },
  {
    id: '6_21',
    name: 'Heroic Battle',
    imageSrc: 'level6/6_21.jpg',
    cutSrc: 'level6/cut/6_21.jpg',
    author: 'ROSA, Salvator',
    year: '1652-64',
  },
  {
    id: '6_22',
    name: 'An Autumn Landscape with a View of Het Steen',
    imageSrc: 'level6/6_22.jpg',
    cutSrc: 'level6/cut/6_22.jpg',
    author: 'RUBENS, Peter Paul',
    year: 'c. 1635',
  },
  {
    id: '6_23',
    name: 'Landscape with a Rainbow',
    imageSrc: 'level6/6_23.jpg',
    cutSrc: 'level6/cut/6_23.jpg',
    author: 'RUBENS, Peter Paul',
    year: 'c. 1638',
  },
  {
    id: '6_24',
    name: 'View of the Town of Alkmaar',
    imageSrc: 'level6/6_24.jpg',
    cutSrc: 'level6/cut/6_24.jpg',
    author: 'RUYSDAEL, Salomon van',
    year: '1645-50',
  },
  {
    id: '6_25',
    name: "Painter's Studio",
    imageSrc: 'level6/6_25.jpg',
    cutSrc: 'level6/cut/6_25.jpg',
    author: 'RYCKAERT, David the Younger',
    year: '1638',
  },
];

export default paintings6;
